// Stoplight capacity colors (gentle/dusty): >70% green, 50-70% yellow, <50% red.
// Labels (Rest/Gentle/Steady/Push) are kept; colors follow the capacity tier.
export const STATE_STYLES = {
  Rest: {
    bg: "bg-[#e8c8b9] dark:bg-[#3a241c]",
    text: "text-[#74331f] dark:text-[#eab79f]",
    subtext: "text-[#96513a] dark:text-[#d09e88]",
    border: "border-[#d9b19f] dark:border-[#5a3527]",
    indicator: "bg-[#bb6647]",
    hex: "#ad4a30",
    label: "Rest",
  },
  Gentle: {
    bg: "bg-[#ecd0c2] dark:bg-[#3a261e]",
    text: "text-[#7e3a26] dark:text-[#ecbaa4]",
    subtext: "text-[#a05a42] dark:text-[#d3a48e]",
    border: "border-[#ddbaa8] dark:border-[#5a3829]",
    indicator: "bg-[#c47455]",
    hex: "#b5573c",
    label: "Gentle",
  },
  Steady: {
    bg: "bg-[#ecd9b2] dark:bg-[#322815]",
    text: "text-[#7a4e0d] dark:text-[#e6c684]",
    subtext: "text-[#97701f] dark:text-[#d0ad6a]",
    border: "border-[#d9c08c] dark:border-[#544019]",
    indicator: "bg-[#c39433]",
    hex: "#a97b1f",
    label: "Steady",
  },
  Push: {
    bg: "bg-[#cdd9b3] dark:bg-[#242b17]",
    text: "text-[#3f4f28] dark:text-[#c5d49b]",
    subtext: "text-[#5f7040] dark:text-[#a9b884]",
    border: "border-[#b8c795] dark:border-[#3d472a]",
    indicator: "bg-[#748a4c]",
    hex: "#647a3c",
    label: "Push",
  },
};

// Cycle-phase colors for the cycle-day trend chart.
export const PHASE_COLORS = {
  Menstrual: "#dc2626",
  Follicular: "#16a34a",
  Ovulatory: "#0891b2",
  Luteal: "#d97706",
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate()
  ).padStart(2, "0")}`;
};

// Shared card surface class (light + dark).
export const CARD =
  "rounded-3xl bg-[#faf4ee] dark:bg-stone-900 border border-stone-100 dark:border-stone-800 shadow-[0_8px_30px_rgb(0,0,0,0.04)]";

// Monday=0 ... Sunday=6
export const todayWeekday = () => (new Date().getDay() + 6) % 7;

export const supplementsForToday = (supplements = []) => {
  const dow = todayWeekday();
  return supplements.filter((s) => !(s.days && s.days.length) || s.days.includes(dow));
};

// Completion progress that fills the capacity-hero border.
// <50%: habits + supplements. 50–70%: + Top 3. >70%: + all fit-today tasks.
export const computeProgress = (tasks, habitLog = [], entry, supplements = []) => {
  if (!entry) return { frac: 0, done: 0, total: 0 };
  let total = 0;
  let done = 0;
  const taken = entry.supplements_taken || [];
  supplementsForToday(supplements).forEach((s) => {
    total += 1;
    if (taken.includes(s.name)) done += 1;
  });
  (tasks?.habits || []).forEach((h) => {
    total += 1;
    if (habitLog.includes(h.id)) done += 1;
  });
  const pct = entry.capacity_pct ?? 0;
  if (pct >= 50) {
    (tasks?.top3 || []).forEach((t) => {
      total += 1;
      if (t.completed) done += 1;
    });
  }
  if (pct > 70) {
    (tasks?.fits_today || []).forEach((t) => {
      total += 1;
      if (t.completed) done += 1;
    });
  }
  return { frac: total ? done / total : 0, done, total };
};
